import { Component, OnInit } from '@angular/core';

import { BreadcrumService, BreadcrumStep } from '../../fw/services/breadcrum.service';

@Component({
    selector: 'app-home',
    template: require('./home.component.html'),
    styles: [require('./home.component.css')]
})
export class HomeComponent implements OnInit {

    constructor(private breadcrumService: BreadcrumService) { }

    ngOnInit() {
        var steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, false, '');
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/home/home.component.ts